<template>
  <a-modal :visible="showDialog" width="80%" :mask="true" :maskClosable="true" :title="title" @ok="handleOk"
    @cancel="handleCancel()">
    <a-form layout="vertical">

      <a-row>
        <a-col :span="8">
          <a-form-item>
            <a-radio-group v-model="platform" button-style="solid" @change="onChange">
              <a-radio-button value="">
                ALL
              </a-radio-button>
              <a-radio-button value="ios">
                <a-icon type="apple" />
              </a-radio-button>
              <a-radio-button value="android">
                <a-icon type="android" />
              </a-radio-button>
            </a-radio-group>
          </a-form-item>
        </a-col>
        <a-col :span="16">
          <a-form-item>
            <a-input v-model="name" allowClear placeholder="产品/应用名称" @pressEnter="onChange">
              <a-icon slot="prefix" type="dropbox" style="color:rgba(0,0,0,.25)" />
            </a-input>
            <!-- <a-button icon="search" @click="onChange()"></a-button> -->
          </a-form-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="4">
          <a-checkbox v-model="isBatch">
            批量操作
          </a-checkbox>
        </a-col>
        <a-col :span="4">
          <a-checkbox v-if="isBatch" v-model="isAll" @change="changeIsAll()">
            全选
          </a-checkbox>
        </a-col>
      </a-row>
      <a-row :gutter="24" style="max-height:50vh;overflow-y: scroll;">
        <a-col :span="8" :key="dataIndex" v-for="(dataItem, dataIndex) in dataList" style="margin-bottom: 10px;">
          <div :class="showCard(dataItem)" @click="dataItem.isHas === false ? addDo(dataItem) : cancelDo(dataItem)">
            <div class="corner" v-if="dataItem.isHas === true">
            </div>
            <div class="corner_text" v-if="dataItem.isHas === true">已授权</div>
            <a-avatar :src="dataItem.icon" style="min-width:32px;height:32px" />
            <span class="card_content">
              {{ dataItem.product_name }}
            </span>
            <a-icon style="font-size: 20px;" :type="dataItem.platform === 'ios' ? 'apple' : 'android'" />
          </div>
        </a-col>
      </a-row>

    </a-form>
    <template slot="footer">
      <a-button type="primary" v-if="isBatch == true" @click="handleOk">批量授权</a-button>
      <a-button @click="handleCancel">关闭</a-button>
    </template>
  </a-modal>
</template>
<script>
import { UserSave } from "../../api/v1/user_api";
import { GetAppList } from "../../api/v1/app_api";

export default {
  name: "UserEditDialog",
  props: ['userInfo', 'appList', 'showDialog', 'title'],
  data() {
    return {
      'loading': true,
      'platform': '',
      'name': '',
      'isBatch': false,
      'isAll': false,
      'dataList': this.appList,
    }
  },
  watch: {
    appList: {
      handler(newVal, oldVal) {
        this.dataList = newVal
      }
    }
  },
  methods: {
    onChange() {
      GetAppList({ platform: this.platform, name: this.name }).then(resp => {
        this.dataLoad = false
        if (resp.code === 200) {
          this.dataList = resp.data
          for (let index = 0; index < this.dataList.length; index++) {
            this.dataList[index].label = this.dataList[index].app_name
            this.dataList[index].value = this.dataList[index].app_id
            if (this.userInfo.app.indexOf(this.dataList[index].app_id) > -1) {
              this.dataList[index].isHas = true
              this.dataList[index].sort = 2
            } else {
              this.dataList[index].isHas = false
              this.dataList[index].sort = 1
            }
          }
          this.dataList.sort((a, b) => {
            return b.sort - a.sort
          }, false)
        }
      })
    },
    addDo(item) {
      if (this.isBatch == true) {
        this.changeCard(item)
        return
      }
      var that = this
      this.$confirm({
        title: '是否确定授予 ' + this.userInfo.name + ' ' + item.app_name + ' 的产品权限',
        centered: true,
        onOk() {
          let index = that.userInfo.app.indexOf(item.app_id)
          if (index > -1) {
            that.onChange()
            return
          }
          that.userInfo.app.push(item.app_id)
          let data = {
            "id": that.userInfo.id,
            "app": that.userInfo.app,
          }
          UserSave(data).then(resp => {
            if (resp.code === 200) {
              that.$message.success(resp.msg)
              that.onChange()
            } else {
              that.$message.error(resp.msg)
            }
          })
        },
        onCancel() { },
        class: 'test',
      });

    },
    cancelDo(item) {
      if (this.isBatch == true) {
        this.changeCard(item)
        return
      }
      var that = this
      this.$confirm({
        title: '是否确定取消 ' + this.userInfo.name + ' ' + item.app_name + ' 的产品权限',
        centered: true,
        onOk() {
          let index = that.userInfo.app.indexOf(item.app_id)
          if (index > -1) {
            that.userInfo.app.splice(index, 1)
          } else {
            that.onChange()
            return
          }
          let data = {
            "id": that.userInfo.id,
            "app": that.userInfo.app,
          }
          UserSave(data).then(resp => {
            if (resp.code === 200) {
              that.$message.success(resp.msg)
              that.onChange()
            } else {
              that.$message.error(resp.msg)
            }
          })
        },
        onCancel() { },
        class: 'test',
      });

    },
    changeIsAll(){
      this.userInfo.app = []
      if (this.isAll){
        this.dataList.forEach(item=>{
          this.userInfo.app.push(item.app_id)
        })
      }
    },
    refresh() {
      this.platform = ''
      this.name = ''
      this.onChange()
    },
    handleOk() {
      console.log(this.userInfo.app)
      let data = {
        "id": this.userInfo.id,
        "app": this.userInfo.app,
      }
      UserSave(data).then(resp => {
        if (resp.code === 200) {
          this.onChange()
          this.$message.success(resp.msg)
          // this.$emit('close-dialog')
        } else {
          this.$message.error(resp.msg)
        }
      })
    },
    handleCancel() {
      this.$emit('close-dialog')
    },
    showCard(item) {
      if (!this.userInfo.app) {
        return 'card'
      }
      if (this.userInfo.app.indexOf(item.app_id) !== -1) {
        return 'card_check';
      } else {
        return 'card'
      }
    },
    changeCard(item) {
      if (!this.userInfo.app) {
        return
      }
      if (this.userInfo.app.indexOf(item.app_id) == -1) {
        this.userInfo.app.push(item.app_id);
      } else {
        for (let index in this.userInfo.app) {
          if (this.userInfo.app[index] == item.app_id) {
            this.userInfo.app.splice(index, 1)
          }
        }
      }
    }
  }
}
</script>

<style scoped>
.ant-checkbox-group-item {
  min-width: 25% !important
}

/deep/ .ant-card-extra {
  padding-top: 10px !important;
  padding-bottom: 10px !important;
}

/deep/ .ant-card-head {
  min-height: 20px;
}

.has {
  border-color: #1890ff !important
}

.card {
  border: 1px solid #787878;
  padding: 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  position: relative;
  border-color: #d9d9d9;
  color: rgba(0, 0, 0, .85);
  font-weight: 500;
  font-size: 16px;
  background-color: #fafafa;
}

.card_check {
  border: 1px solid #787878;
  padding: 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  position: relative;
  border-color: #d9d9d9;
  color: rgba(0, 0, 0, .85);
  font-weight: 500;
  font-size: 16px;
  background-color: #df9e85;
}

.corner {
  position: absolute;
  right: 0;
  top: 0;
  border-color: transparent #1890ff;
  border-width: 0 45px 45px 0;
  border-style: solid;
  text-align: center
}

.corner_text {
  position: absolute;
  right: 0;
  top: 8px;
  transform: rotate(45deg);
  font-size: 12px;
  color: #eee;
}

.card_content {
  max-width: 150px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>




// WEBPACK FOOTER //
// src/components/V1/UserAppDialog.vue